exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.makeMeInVisible[data-v-ff5de120] {\n    visibility: hidden;\n}\n", ""]);

// exports
